var $ = require('jquery');

var flags = {};

/**
 * Set a particular profile flag. Editable flags are listed in profile/models.py as
 * Profile.USER_EDITABLE_FLAGS. Any other values will return a 404.
 * @param {string} flag - the profile flag to set
 * @param {boolean} [value=true] Set the flag by default
 * @param {function} [callback] - what to do when the request is complete
 */
flags.update = function (flag, value, callback) {
    if (typeof(value) === 'undefined') {
        value = true;
    }
    callback = callback || function () {};
    var url = (value ? '/profile/set_flag/' : '/profile/unset_flag/') + flag + '/';
    $.post(url)
        .then(function (response) {
            callback(response);
        })
        .fail(function (xhr, error, error_text) {
            callback({
                success: false,
                error: error_text, // ex: NOT FOUND
                status: xhr.status // ex: 404
            });
        });
};

/**
 * Controller for setting USER_EDITABLE_FLAGS. Attach to an element with a data-flag
 * attribute, and clicking the element will set the flag.
 * @param {JQuery} $button
 */
flags.controller = function ($button) {
    var flagName = $button.data('flag') || null;
    if(flagName !== null) {
        $button.on('click', function () {
            flags.update(flagName, true);
        });
    }
};

module.exports = flags;
